import { Card, CardContent, Typography, Grid, Button, Box, Chip, TextField, DialogActions, DialogContent, DialogTitle, Dialog, Container, Stack, FormControl, InputLabel, Select, OutlinedInput, LinearProgress, FormControlLabel, Checkbox, Alert } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MRT_Localization_FR } from 'material-react-table/locales/fr';
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import React, { useState } from "react";
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import PersonIcon from "@mui/icons-material/Person";
import DeleteIcon from "@mui/icons-material/Delete";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import axios from "axios";
import ClearIcon from "@mui/icons-material/Clear";
import { Autocomplete } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import KeyboardIcon from '@mui/icons-material/Keyboard';
import ComputerIcon from '@mui/icons-material/Computer';
import MemoryIcon from '@mui/icons-material/Memory';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import RateReviewIcon from '@mui/icons-material/RateReview';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});


export default function ClientPeople() {

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

// --- STATE ---
const [selectedProductLicenses, setSelectedProductLicenses] = useState([]); // array d'objets produit



    const { data: users = [], loading, error } = useSelector((state) => state.users.users);

    const { data: o365Licenses = [], o365LicensesLoading, o365LicensesError } = useSelector((state) => state.o365.licenses);
    const { data: o365Users = [], o365UsersLoading, o365UsersError } = useSelector((state) => state.o365.users);

    const [products, setProducts] = useState()
    const [page, setPage] = useState(0);           // 0-based pour MRT
    const [pageSize, setPageSize] = useState(50);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [includeDeleted, setIncludeDeleted] = useState(false);
    // dans ton state
const [computerType, setComputerType] = useState("");

const handleSelectComputer = (type) => {
  setComputerType(type);
  setFormValues((prev) => ({ ...prev, computerType: type }));
};

const handleClearComputer = () => {
  setComputerType("");
  setFormValues((prev) => ({ ...prev, computerType: "" }));
};

const [selectedPeripherals, setSelectedPeripherals] = useState([]); // ex: ["screen2", "dock"]





const togglePeripheral = (value) => {
  setSelectedPeripherals((prev) => {
    const exists = prev.includes(value);
    const next = exists ? prev.filter((v) => v !== value) : [...prev, value];
    // on garde ça dans formValues aussi, pour l'API
    setFormValues((f) => ({ ...f, peripherals: next }));
    return next;
  });
};

const clearPeripherals = () => {
  setSelectedPeripherals([]);
  setFormValues((f) => ({ ...f, peripherals: [] }));
};




    const fetchProducts = async (p = page, l = pageSize, q = search) => {
      try {
        const res = await api.get('/api/products', {
          params: {
            page: p + 1,           // API en 1-based
            limit: l,
            search: q || undefined,
            includeDeleted: includeDeleted,
          },
        });
        let data = res.data?.data || [];
        console.log(data)

        // Si tu veux filtrer par nom d’organisation (contexte), fais-le ici si ton API ne le gère pas:

        setProducts(data);
      } catch (e) {
        console.error('Fetch products failed:', e);
      } finally {
      }
    };

    useEffect(() => {
      fetchProducts(0, pageSize, '');
    
    }, [])

    // --- MEMO OPTIONS ---
const licenseProducts = useMemo(
  () => (products ?? []).filter((p) => p.category === "Licence"),
  [products]
);

// --- HELPERS ---
const handleLicensesChange = (newValue) => {
  setSelectedProductLicenses(newValue);
  setFormValues((prev) => ({
    ...prev,
    productLicenses: newValue.map((p) => p._id), // pour l'API
  }));
};

const handleRemoveChip = (id) => {
  const next = selectedProductLicenses.filter((p) => p._id !== id);
  handleLicensesChange(next);
};

    
    
    const columns = useMemo(
      () => [
        {
          id: 'users',
          columns: [
            {
              accessorKey: 'firstname',
              header: 'Prénom',
              size: 150,
              filterVariant: 'autocomplete',
            },
            {
              accessorKey: 'lastname',
              header: 'Nom',
              size: 150,
              filterVariant: 'autocomplete',
            },
            {
              accessorKey: 'email',
              header: 'Email',
              size: 200,
              filterVariant: 'autocomplete',
            },
            {
              accessorKey: 'jobTitle',
              header: 'Poste',
              size: 50,
              filterVariant: 'autocomplete',
            },
            {
              accessorKey: 'status',
              header: 'Statut',
              size: 100,
              filterVariant: 'autocomplete',
              Cell: ({ cell }) => {
                const status = cell.getValue();
                let label = '';
                let color = 'default';

                switch (status) {
                  case 'active':
                    label = 'Actif';
                    color = 'success';
                    break;
                  case 'inactive':
                    label = 'Inactif';
                    color = 'default';
                    break;
                  case 'processing':
                    label = 'En cours de traitement';
                    color = 'warning';
                    break;
                  case 'pending':
                    label = 'En attente';
                    color = 'info';
                    break;
                  default:
                    label = status || 'Inconnu';
                    color = 'default';
                }

                return <Chip label={label} color={color} size="small" />;
              },
            },
            {
              accessorFn: (row) =>
                Array.isArray(row.phones) && row.phones.length > 0
                  ? row.phones.join(', ')
                  : '',
              id: 'phones',
              header: 'Téléphones',
              size: 200,
              Cell: ({ row }) =>
                Array.isArray(row.original.phones) && row.original.phones.length > 0
                  ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                      {row.original.phones.map((phone, idx) => (
                        <Typography key={idx} variant="body2">{phone}</Typography>
                      ))}
                    </Box>
                  )
                  : <Typography variant="body2" color="textSecondary">Aucun</Typography>,
              filterVariant: 'autocomplete',
            },
            {
              accessorFn: (row) =>
                Array.isArray(row.emails) && row.emails.length > 0
                  ? row.emails.join(', ')
                  : '',
              id: 'emails',
              header: 'Emails secondaires',
              size: 200,
              Cell: ({ row }) =>
                Array.isArray(row.original.emails) && row.original.emails.length > 0
                  ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                      {row.original.emails.map((email, idx) => (
                        <Typography key={idx} variant="body2">{email}</Typography>
                      ))}
                    </Box>
                  )
                  : <Typography variant="body2" color="textSecondary">Aucun</Typography>,
              filterVariant: 'autocomplete',
            },
          ],
        },
      ],
      [],
    );

    // Menu actions constants
    const USER_ACTIONS = [
        {
            label: "Voir",
            icon: <VisibilityIcon fontSize="small" />,
            onClick: (row) => {
                // Action: View details
                // e.g., navigate(`/users/${row.original.id}`)
            },
        },
        {
            label: "Éditer",
            icon: <EditIcon fontSize="small" />,
            onClick: (row) => {
                // Action: Edit user
                // e.g., openEditDialog(row.original)
            },
        },
        {
            label: "Supprimer",
            icon: <DeleteIcon fontSize="small" />,
            onClick: (row) => {
                // Action: Delete user
                // e.g., openDeleteDialog(row.original)
            },
        },
    ];

    // Dropdown menu component for row actions
    function RowActionsMenu({ row }) {
        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);

        const handleOpen = (event) => setAnchorEl(event.currentTarget);
        const handleClose = () => setAnchorEl(null);

        const handleAction = (action) => {
            action.onClick(row);
            handleClose();
        };

        return (
            <>
                <IconButton size="small" onClick={handleOpen}>
                    <MoreVertIcon />
                </IconButton>
                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    {USER_ACTIONS.map((action) => (
                        <MenuItem key={action.label} onClick={() => handleAction(action)}>
                            <ListItemIcon>{action.icon}</ListItemIcon>
                            <ListItemText>{action.label}</ListItemText>
                        </MenuItem>
                    ))}
                </Menu>
            </>
        );
    }

    const table = useMaterialReactTable({
    localization: MRT_Localization_FR,
    enableGlobalFilter: true,
    enableColumnFilters: true,

            columns,
            data: users ? users : null,
            enableColumnFilterModes: true,
            enableColumnOrdering: true,
            enableGrouping: true,
            enableColumnPinning: true,
            enableFacetedValues: true,
            enableRowActions: true,
            initialState: {
      showColumnFilters: true,
      showGlobalFilter: true,

                    columnVisibility: {
                            phones: false,
                            emails: false,
                    },
                    density: "compact",
                    columnPinning: {
                            left: ['mrt-row-expand', 'mrt-row-select'],
                            right: ['mrt-row-actions'],
                    },
                    pagination: {
                            pageSize: 50,
                    }
            },
            paginationDisplayMode: 'pages',
            positionToolbarAlertBanner: 'bottom',
            enableRowSelection: true,
            muiSearchTextFieldProps: {
                    size: 'small',
                    variant: 'outlined',
            },
            muiPaginationProps: {
                    color: 'secondary',
                    rowsPerPageOptions: [50, 100, 150],
                    shape: 'rounded',
                    variant: 'outlined',
            },
            renderRowActions: ({ row }) => <RowActionsMenu row={row} />,
    });


    
const [openDialog, setOpenDialog] = useState(false);
const [formValues, setFormValues] = useState({
    lastname: '',
    firstname: '',
    email: '',
    jobTitle: '',
});

const handleOpenDialog = () => setOpenDialog(true);
const handleCloseDialog = () => setOpenDialog(false);

const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
};

const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: handle form submission (e.g., dispatch action or API call)
    handleCloseDialog();
};


return (
    <Box>
        <Box>
            <Typography variant="h6" my={1} mb={3}>Gestion du personnel</Typography>
            <Typography variant="subtitle1" color="textSecondary" gutterBottom>
                Gérez le personnel de votre organisation.
            </Typography>
        </Box>
        <Button
            variant="contained"
            color="primary"
            sx={{ mb: 2 }}
            onClick={handleOpenDialog}
        >
            Demande de création utilisateur
        </Button>
        <MaterialReactTable table={table} />

        <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
            <DialogTitle sx={{ fontWeight: 700, fontSize: 32, textAlign: 'center', pt: 4 }}>
                Entrée employé
            </DialogTitle>
            <Typography variant="subtitle1" color="textSecondary" sx={{ textAlign: 'center', mb: 2 }}>
                Configuration des accès et du matériel pour un nouvel employé
            </Typography>
            <DialogContent>
                <Container>

                {/* Informations personnelles */}
               <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                <PersonIcon />
                <Typography variant="h6">Informations personnelles</Typography>
              </Stack>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField name="firstname" label="Prénom *" fullWidth required onChange={handleChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField name="lastname" label="Nom *" fullWidth required onChange={handleChange} />
                </Grid>
                <Grid item xs={12}>
                  <TextField name="email" label="Adresse email *" type="email" fullWidth required onChange={handleChange} />
                </Grid>
                <Grid item xs={12}>
                  <TextField name="position" label="Poste / Fonction *" fullWidth required onChange={handleChange} />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Services & Licences   */}
          <Card variant="outlined" sx={{ my: 2 }}>
                <CardContent>
                  <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                    <WorkspacePremiumIcon />
                    <Typography variant="h6">Licences & Services</Typography>
                  </Stack>

                  <FormControl component="fieldset" sx={{ mb: 2 }}>
                    <Typography variant="subtitle1">Sélection licences</Typography>
                    <Stack direction="row" spacing={2}>
                      <FormControlLabel
                        control={<Checkbox name="o365" checked={formValues.o365 || false} onChange={handleChange} />}
                        label="O365"
                      />
                      <FormControlLabel
                        control={<Checkbox name="eset" checked={formValues.eset || false} onChange={handleChange} />}
                        label="ESET"
                      />
                      <FormControlLabel
                        control={<Checkbox name="vdc" checked={formValues.vdc || false} onChange={handleChange} />}
                        label="VDC"
                      />
                    </Stack>
                  </FormControl>

                  {/* Affichage état licence */}
                  {formValues.o365 && (
                    <Alert severity={(/* logique dispo */ true) ? "success" : "error"}>
                      {true ? "Licence disponible – mail envoyé à tech@toolbox.re"
                            : "Licence indisponible – mail envoyé à adv@toolbox.re"}
                    </Alert>
                  )}
                </CardContent>
              </Card>

              {/* Licences Microsoft 365 */}
              <Card variant="outlined" sx={{ my: 2 }}>
                   <CardContent>
              

                <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                    <WorkspacePremiumIcon />
                    <Typography variant="h6">Licence Microsoft 365</Typography>
                </Stack>
                <Box>
                {o365Licenses.length > 0 && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                        {o365Licenses.map((license) => {
                            const percent = Math.round((license.used / license.total) * 100);
                                return (
                                <Box key={license.id}>
                                    <Typography variant="subtitle2">
                                    {license.licenseName} ({license.used} / {license.total})
                                    </Typography>
                                    <LinearProgress variant="determinate" value={percent} sx={{ height: 8, borderRadius: 1 }} />
                                </Box>
                                );
                        })}
                    </Box>)}
            </Box>
              <FormControl fullWidth> 
                <InputLabel>Licence</InputLabel>
             <Select
                  name="license"
                //   value={selectedLicense}
                //   onChange={(e) => setSelectedLicense(e.target.value)}
                  input={<OutlinedInput label="Licence" />}
                >
                  {o365Licenses.map((lic) => (
                    <MenuItem key={lic._id} value={lic._id} disabled={lic.used >= lic.total}>
                      {lic.licenseName} ({lic.used}/{lic.total})
                    </MenuItem>
                  ))}
                </Select>
            
              </FormControl>
            </CardContent>
              {/* Autocomplete multi pour licences produits */}
<FormControl fullWidth sx={{ mt: 2 }}>
  <Autocomplete
    multiple
    disableCloseOnSelect
    options={licenseProducts}
    value={selectedProductLicenses}
    onChange={(e, newValue) => handleLicensesChange(newValue)}
    getOptionLabel={(option) => option?.name ?? ""}
    isOptionEqualToValue={(opt, val) => opt._id === val._id}
    loading={!products}
    renderInput={(params) => (
      <TextField {...params} label="Licences produits" placeholder="Rechercher..." />
    )}
    // Checkbox dans la liste + éviter d'afficher les tags DANS l'input
    renderOption={(props, option, { selected }) => (
      <li {...props} key={option._id}>
        <Checkbox
          icon={icon}
          checkedIcon={checkedIcon}
          checked={selected}
          sx={{ mr: 1 }}
        />
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body2">{option.name}</Typography>
          {option.sku && (
            <Typography variant="caption" color="text.secondary">
              {option.sku}
            </Typography>
          )}
        </Box>
      </li>
    )}
    renderTags={() => null} // on affiche les chips en-dessous, pas dans l'input
  />

  {/* Chips des sélections */}
  {selectedProductLicenses.length > 0 && (
    <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 1 }}>
      {selectedProductLicenses.map((p) => (
        <Chip
          key={p._id}
          label={p.name}
          onDelete={() => handleRemoveChip(p._id)}
          variant="outlined"
        />
      ))}
    </Box>
  )}
</FormControl>
          </Card>
                {/* Matériel informatique */}
<Card variant="outlined" sx={{ my: 2  }}>
  <CardContent>
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
      <Typography variant="h5" sx={{ display: "flex", alignItems: "center" }}>
        <MemoryIcon sx={{ mr:1 }} /> 
        Matériel informatique
      </Typography>

      {/* Bouton Clear global */}
      {computerType && (
        <Button
          size="small"
          variant="outlined"
          color="secondary"
          onClick={handleClearComputer}
        >
          Effacer le choix
        </Button>
      )}
    </Box>

    <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
      Configuration du poste de travail et des accessoires
    </Typography>
    <Typography variant="h6" display={'flex'} alignItems={'center'}><ComputerIcon  sx={{ mr:1 }} />Ordinateurs</Typography>

    <Grid container spacing={2}>
      {products?.filter(product => product.category === "Ordinateurs").map((product) => (
        <Grid item size={{xs:12, sm:12}} key={product.value}>
          <Box
            onClick={() => handleSelectComputer(product.value)}
            sx={{
              p: 2,
              borderRadius: 2,
              border: computerType === product.value ? "2px solid #1976d2" : "1px solid #e0e0e0",
              boxShadow: computerType === product.value ? 4 : 1,
              cursor: "pointer",
              backgroundColor: computerType === product.value ? "#e3f2fd" : "#fafbfc",
              transition: "all 0.2s ease-in-out",
              "&:hover": { boxShadow: 4 },
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
              {product.name}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {product.description}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  </CardContent>




      {/* PÉRIPHÉRIQUES – multi-sélection en cards cliquables */}
      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
          <Typography variant="h6" display={'flex'} alignItems={'center'}><HeadphonesIcon sx={{ mr:1 }} />Périphériques</Typography>

          {selectedPeripherals.length > 0 && (
            <Button
              size="small"
              variant="outlined"
              color="secondary"
              onClick={clearPeripherals}
            >
              Effacer la sélection ({selectedPeripherals.length})
            </Button>
          )}
        </Box>

        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Choisissez un ou plusieurs accessoires
        </Typography>

        <Grid container spacing={2}>
          {products?.filter(product => product.category === "Périphérique").map((product) => {

            const selected = selectedPeripherals.includes(product.value);
            return (
              <Grid item size={{xs:12, sm:12, md:12}}  key={product.value}>
                <Box
                  onClick={() => togglePeripheral(product.value)}
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    border: selected ? "2px solid #1976d2" : "1px solid #e0e0e0",
                    boxShadow: selected ? 4 : 1,
                    cursor: "pointer",
                    backgroundColor: selected ? "#e3f2fd" : "#fafbfc",
                    transition: "all 0.2s ease-in-out",
                    position: "relative",
                    "&:hover": { boxShadow: 4 },
                  }}
                >
                  {/* petit indicateur check quand sélectionné */}
                  {selected && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        bgcolor: "primary.main",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        fontSize: 14,
                        lineHeight: 1,
                      }}
                    >
                      ✓
                    </Box>
                  )}

                  <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                    {product.label}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {product.desc}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </CardContent>
    </Card>





                {/* Notes additionnelles */}
                <Card variant="outlined" sx={{ my: 2 }}>
                    <CardContent>
                        <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                          <RateReviewIcon sx={{mr:1}}/>
                            {/* <span role="img" aria-label="notes" style={{ marginRight: 8 }}>📝</span> */}
                            Notes additionnelles
                        </Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                            Informations complémentaires ou besoins spécifiques
                        </Typography>
                        <TextField
                            label="Besoins spécifiques, logiciels particuliers, contraintes..."
                            name="additionalNotes"
                            multiline
                            minRows={3}
                            fullWidth
                            variant="outlined"
                            value={formValues.additionalNotes || ''}
                            onChange={handleChange}
                        />
                    </CardContent>
                </Card>
                
            </Container>

            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button onClick={handleCloseDialog}>Annuler</Button>
                <Button onClick={handleSubmit} variant="contained" type="submit">
                    Créer
                </Button>
            </DialogActions>
        </Dialog>
    </Box>
);
}
